import { recommendationsUrl } from '../../spa/Utils/LocalizedUrls';
import {
    SEO_URL_SUFFIX_RECOMMENDATIONS,
    SEO_URL_SUFFIX_RECENTLY_WON,
    SEO_URL_SUFFIX_RECENTLY_BACKED,
    SEO_URL_SUFFIX_TRENDING,
} from '../../spa/Utils/SeoUrls';

export const BB_RECALL_BASE_URL = `/${recommendationsUrl()}`;
export const BB_RECALL_FACIL_URL = '/recall';
export const BB_RECALL_CSS_CLASS_BLOCK_NAME = 'bb-recall';
export const BB_RECALL_APP_CSS_CLASS = `${BB_RECALL_CSS_CLASS_BLOCK_NAME}-home-app`;
export const BB_RECALL_APP_MAIN_CSS_ID = `${BB_RECALL_CSS_CLASS_BLOCK_NAME}-main-app`;
export const BB_RECALL_GA_COMPONENT_PREFIX = 'recall';

export const BB_BETCARD_CSS_CLASS_BLOCK_NAME = 'bb-betcard';

export const BB_RECALL_LOADING_CSS_CLASS_BLOCK_NAME = `${BB_RECALL_CSS_CLASS_BLOCK_NAME}__loading`;

export const BB_RECALL_PAGE_ENDPOINT = `${BB_RECALL_FACIL_URL}-req/getWidgetBetCards`;
export const BB_RECALL_ALL_BETCARDS_ENDPOINT = `${BB_RECALL_FACIL_URL}-req/getAllBetCards`;

export const BB_RECALL_WIDGET_TYPE_MAIN = 'MAIN_PAGE_WIDGET';
export const BB_RECALL_WIDGET_TYPE_HOME = 'HOME_PAGE_WIDGET';

export const BB_RECALL_INFO_CLASS = `${BB_RECALL_CSS_CLASS_BLOCK_NAME}__info`;
export const BB_RECALL_INFO_ICON_CLASS = `${BB_RECALL_INFO_CLASS}-icon`;
export const BB_RECALL_INFO_TITLE_CLASS = `${BB_RECALL_INFO_CLASS}-title`;

export const BB_RECALL_WON_TYPE = 'won';
export const BB_RECALL_BACKED_TYPE = 'backed';
export const BB_RECALL_TRENDING_TYPE = 'trending';
export const BB_RECALL_TYPES = [
    BB_RECALL_WON_TYPE,
    BB_RECALL_BACKED_TYPE,
    BB_RECALL_TRENDING_TYPE,
];

export const BB_RECALL_ALL_TYPE = 'all';

export const BB_RECALL_TYPES_CONTEXTS = {
    [SEO_URL_SUFFIX_RECOMMENDATIONS]: BB_RECALL_ALL_TYPE,
    [SEO_URL_SUFFIX_RECENTLY_WON]: BB_RECALL_WON_TYPE,
    [SEO_URL_SUFFIX_RECENTLY_BACKED]: BB_RECALL_BACKED_TYPE,
    [SEO_URL_SUFFIX_TRENDING]: BB_RECALL_TRENDING_TYPE,
};

export const BB_RECALL_ALL_TAB_IDX = 0;
export const BB_RECALL_WON_TAB_IDX = 1;
export const BB_RECALL_BACKED_TAB_IDX = 2;
export const BB_RECALL_TRENDIG_TAB_IDX = 3;

export const BB_RECALL_WIDGET_PREFIX = `${BB_RECALL_GA_COMPONENT_PREFIX}-widget`;

export const BB_RECALL_GA_COMPONENT_HOME_TYPES = new Map([
    [BB_RECALL_WON_TYPE, `${BB_RECALL_WIDGET_PREFIX}-${BB_RECALL_WON_TYPE}-home`],
    [BB_RECALL_BACKED_TYPE, `${BB_RECALL_WIDGET_PREFIX}-${BB_RECALL_BACKED_TYPE}-home`],
    [BB_RECALL_TRENDING_TYPE, `${BB_RECALL_WIDGET_PREFIX}-${BB_RECALL_TRENDING_TYPE}-home`],
]);

export const BB_RECALL_GA_COMPONENT_ALL_TYPES = new Map([
    [BB_RECALL_WON_TYPE, `${BB_RECALL_WIDGET_PREFIX}-${BB_RECALL_WON_TYPE}-all`],
    [BB_RECALL_BACKED_TYPE, `${BB_RECALL_WIDGET_PREFIX}-${BB_RECALL_BACKED_TYPE}-all`],
    [BB_RECALL_TRENDING_TYPE, `${BB_RECALL_WIDGET_PREFIX}-${BB_RECALL_TRENDING_TYPE}-all`],
]);

export const BB_RECALL_GA_COMPONENT_SEPARATE_TYPES = new Map([
    [BB_RECALL_WON_TYPE, `${BB_RECALL_WIDGET_PREFIX}-${BB_RECALL_WON_TYPE}`],
    [BB_RECALL_BACKED_TYPE, `${BB_RECALL_WIDGET_PREFIX}-${BB_RECALL_BACKED_TYPE}`],
    [BB_RECALL_TRENDING_TYPE, `${BB_RECALL_WIDGET_PREFIX}-${BB_RECALL_TRENDING_TYPE}`],
]);

export const BB_RECALL_NO_RESUTLS_ID = `${BB_RECALL_CSS_CLASS_BLOCK_NAME}__main-no-results`;

export const I18N_PREFIX = 'recall';

export const BB_RECALL_ALL_TEXT = `${I18N_PREFIX}.all`;
export const BB_RECALL_WON_TEXT = `${I18N_PREFIX}.recently_won`;
export const BB_RECALL_BACKED_TEXT = `${I18N_PREFIX}.recently_backed`;
export const BB_RECALL_TRENDING_TEXT = `${I18N_PREFIX}.trending`;
export const BB_RECALL_LOGIN_TO_SEE_TEXT = `${I18N_PREFIX}.login_to_see`;
export const BB_RECALL_NO_RECOMMENDED_TITLE_TEXT = `${I18N_PREFIX}.no_recommended`;
export const BB_RECALL_NO_RECOMMENDED_TEXT = `${I18N_PREFIX}.no_recommended_text`;
export const BB_RECALL_LOGIN_TEXT = `${I18N_PREFIX}.login`;

export const RECALL_YOU_WON = `${I18N_PREFIX}.you_won`;
export const RECALL_YOU_WON_LONG = `${I18N_PREFIX}.you_won_long`;
export const RECALL_YOU_BACKED = `${I18N_PREFIX}.you_backed`;
export const RECALL_YOU_BACKED_LONG = `${I18N_PREFIX}.you_backed_long`;
export const RECALL_PPL_BACKED = `${I18N_PREFIX}.ppl_backed`;
export const RECALL_PPL_BACKED_LONG = `${I18N_PREFIX}.trending_long`;

export const BB_RECALL_PAGE_HOME = 'home';
export const BB_RECALL_PAGE_SINGLE = 'single';
export const BB_RECALL_PAGE_MAIN = 'main';

export const BB_RECALL_GTM_HOMEPAGE = 'homepage';
export const BB_RECALL_GTM_RECOMMENDATIONS = 'recommendations';
const BB_RECALL_RECENT_PREFIX = 'recently-';
const BB_RECALL_WIDGET_SUFFIX = '-widget';
export const BB_RECALL_GTM_ACTION = 'see-all';
export const BB_RECALL_GTM_WIDGET_TYPES = new Map([
    [BB_RECALL_WON_TYPE, `${BB_RECALL_RECENT_PREFIX}${BB_RECALL_WON_TYPE}${BB_RECALL_WIDGET_SUFFIX}`],
    [BB_RECALL_BACKED_TYPE, `${BB_RECALL_RECENT_PREFIX}${BB_RECALL_BACKED_TYPE}${BB_RECALL_WIDGET_SUFFIX}`],
    [BB_RECALL_TRENDING_TYPE, `${BB_RECALL_TRENDING_TYPE}${BB_RECALL_WIDGET_SUFFIX}`],
]);

// instruction_card
export const I18N_INSTRUCTION_PREFIX = 'instruction_cards';
export const INSTRUCTION_CONTENT_WON = `${I18N_INSTRUCTION_PREFIX}.won`;
export const INSTRUCTION_CONTENT_BACKED = `${I18N_INSTRUCTION_PREFIX}.backed`;
export const INSTRUCTION_CONTENT_TRENDING = `${I18N_INSTRUCTION_PREFIX}.trending`;

export const INSTRUCTION_CONTENT_MAIN_WON = `${I18N_INSTRUCTION_PREFIX}.main_won`;
export const INSTRUCTION_CONTENT_MAIN_BACKED = `${I18N_INSTRUCTION_PREFIX}.main_backed`;
export const INSTRUCTION_CONTENT_MAIN_TRENDING = `${I18N_INSTRUCTION_PREFIX}.main_trending`;

export const RECALL_INSTRUCTION_CARD_DISMISS = '/instruction_cards/dismiss/';
export const BB_RECALL_DISMISS_TYPES = new Map([
    [BB_RECALL_WON_TYPE, 'recommendations_recently_won'],
    [BB_RECALL_BACKED_TYPE, 'recommendations_recently_backed'],
    [BB_RECALL_TRENDING_TYPE, 'recommendations_trending'],
]);
export const GTM_INSTRUCTION_ALL_TAB = 'all';

export const WS_HANDLER_COMPONENT_NAME = 'Recall';
